const selfSelector = (state) => state.favouritesCurrencyList

export default selfSelector
